import api from './baseApi';

export function getTransactionsByUserId(userId, params) {
    return api.get(`transactions/client/${userId}`, params);
}

export function getCreditsByUserId(userId) {
    return api.get(`transactions/employeeCredits/${userId}`);
}